import { getFlightMetasearchDetails } from '@apis/flight';

import { useAxiosQuery, UseAxiosQueryOptions } from '@hooks/useAxiosQuery';

import { FlightSearchResultSearch } from '@wegoTypes/flights/metasearch/flightSearchResultSearch';

export const getFlightMetasearchDetailsKey = 'flight-metasearch-details';

type GetFlightMetasearchDetailsParams = {
  searchId: string;
};

export const useGetFlightMetasearchDetails = (
  params: GetFlightMetasearchDetailsParams,
  options: UseAxiosQueryOptions<FlightSearchResultSearch>,
) => {
  return useAxiosQuery({
    queryKey: [getFlightMetasearchDetailsKey, params],
    queryFn: () => getFlightMetasearchDetails(params.searchId),
    staleTime: 1000 * 60 * 30, // 30 minutes
    ...options,
  });
};
